import React, { useEffect, useRef } from 'react';
import {
  ModalButtonRow,
  ModalCard,
  ModalCloseButton,
  ModalOverlay,
  AskAICtaPrimaryButton,
  AskAICtaSecondaryButton,
} from '../AskAIPageStyles';
import { decodeHTML } from '../../../utility/utils.js';
import {contentClick} from "../../../common/Analytics/GAWrapper.jsx";


const NewSearchModal = ({ showNewSearchModal, setShowNewSearchModal, handleNewSearchConfirm, askAiData, triggerButtonRef }) => {
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);
  const previousStateRef = useRef(showNewSearchModal);

  const closeModal = () => {
    setShowNewSearchModal(false);
  };

  useEffect(() => {
    if (showNewSearchModal) {
      closeButtonRef.current?.focus();
      previousStateRef.current = true;
    } else if (previousStateRef.current && triggerButtonRef?.current) {
      triggerButtonRef.current.focus();
      previousStateRef.current = false;
      return;
    }

    const rafId = window.requestAnimationFrame(() => {
      closeButtonRef.current?.focus();
    });

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== 'Tab' || !modalRef.current) return;

      const focusables = modalRef.current.querySelectorAll(
        'button:not([disabled])'
      );

      if (!focusables.length) {
        event.preventDefault();
        return;
      }

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;

      if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      window.cancelAnimationFrame(rafId);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [showNewSearchModal, setShowNewSearchModal]);

  if (!showNewSearchModal) return null;

  return (
    <ModalOverlay onClick={closeModal}>
      <ModalCard ref={modalRef} role="dialog" aria-modal="true" aria-labelledby='modal-title' aria-describedby='modal-desc' tabIndex={-1} onClick={(e) => e.stopPropagation()}>
        <ModalCloseButton type="button" onClick={closeModal} aria-label="Close" ref={closeButtonRef}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L15 15M15 1L1 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </ModalCloseButton>
        <h2 id="modal-title" className="vds-title-lg mobile-vds-title-md font-eDS-bold">
          {decodeHTML(askAiData?.resultsPageTexts?.schModalTitle)}
        </h2>
        <div id="modal-desc" className="vds-body-lg mt-8X sm-mt-6X">
          {decodeHTML(askAiData?.resultsPageTexts?.schModalDesc)}
        </div>
        <ModalButtonRow>
          <AskAICtaPrimaryButton type="button" onClick={() => {
            contentClick(
                askAiData?.resultsPageTexts?.schCnfrmBtnTxt || 'Confirm',
                window.location.href,
                '',
                'askai_new_search_modal_confirm'
              );
              handleNewSearchConfirm();
              }}>
            <span className="vds-body-lg font-eDS-bold">{askAiData?.resultsPageTexts?.schCnfrmBtnTxt}</span>
          </AskAICtaPrimaryButton>
          <AskAICtaSecondaryButton type="button" onClick={() => {
              // Add tracking for Cancel
              contentClick(
                askAiData?.resultsPageTexts?.schCnclBtnTxt || 'Cancel',
                window.location.href,
                '',
                'askai_new_search_modal_cancel'
              );
              closeModal();
            }}>
            <span className="vds-body-lg font-eDS-bold">{askAiData?.resultsPageTexts?.schCnclBtnTxt}</span>
          </AskAICtaSecondaryButton>
        </ModalButtonRow>
      </ModalCard>
    </ModalOverlay>
  );
};

export default NewSearchModal;
